import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/referral/ReferralClient.tsx");
